import React from "react";
import { Table, Spin, Card, Statistic, Button, Modal } from "antd";
import StockNotInOpnamePage from "./StockNotInOpnamePage";
import { getOpnameSummary } from "../../../Services/StockService";

const StockOpnameSummaryPage = () => {
  const [loading, setLoading] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedCounter, setSelectedCounter] = React.useState(null);

  const load = React.useCallback(async () => {
    setLoading(true);
    try {
      const resp = await getOpnameSummary();
      setRows(resp?.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  const totalAll = Array.isArray(rows)
    ? rows.reduce((s, r) => s + (Number(r?.totalCurrentQuantity) || 0), 0)
    : 0;

  const columns = [
    { title: "Counter Code", dataIndex: "counterCode", key: "counterCode" },
    {
      title: "Total Current Quantity",
      dataIndex: "totalCurrentQuantity",
      key: "totalCurrentQuantity",
    },
    {
      title: "Actions",
      key: "actions",
      render: (row) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedCounter(row.counterCode);
            setModalOpen(true);
          }}
        >
          View Not In Opname
        </Button>
      ),
    },
  ];

  return (
    <div style={{ width: "100vw", padding: 20, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
      <div style={{ width: "80vw", maxWidth: "100vw", marginBottom: 12 }}>
        <Card size="small" style={{ minWidth: 220 }}>
          <Statistic title="Total Quantity (All Counters)" value={totalAll} />
        </Card>
      </div>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={rows}
          rowKey={(r) => r.counterCode}
          pagination={false}
        />
      </Spin>
      <Modal
        title={`Not In Opname - ${selectedCounter || "All Counters"}`}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width="80vw"
        destroyOnClose
      >
        {selectedCounter ? (
          <StockNotInOpnamePage
            history={{}}
            userData={{}}
            forcedCounterCode={selectedCounter}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default StockOpnameSummaryPage;


